import React from "react";
import "./smallModal.css";
import functionDate from "../../utils/formatarData";
import Textnotifications from "../../utils/notifications";
import SmallModal from "../fluxo-tax/smallModal/smallModal";
import { useRoles } from "../../hooks/roles";

interface CorrigirModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  corrigirText: string;
  setCorrigirText: (value: string) => void;
  ncmCode?: string;
  setNcmCode?: (value: string) => void;
  isButtonDisabled: boolean;
  onDisableButton: (disabled: boolean) => void;
  isSubmitting?: boolean;
  ncmApiError?: string | null;
  setNcmApiError?: (value: string | null) => void;
  mode?: "material" | "tax";
}

export const CorrigirModal: React.FC<CorrigirModalProps> = ({
  open,
  onClose,
  onConfirm,
  corrigirText,
  setCorrigirText,
  ncmCode,
  setNcmCode,
  isButtonDisabled,
  onDisableButton,
  isSubmitting,
  ncmApiError,
  setNcmApiError,
  mode,
}) => {
  const { isTax } = useRoles();

  let corrigirHtml = "";

  if (!isTax) {
    corrigirHtml = "Deseja corrigir o Laudo Técnico?";
  } else if (mode === "material") {
    corrigirHtml = functionDate.formatBodyText(
      Textnotifications.getCorrigirPrompt()
    );
  } else {
    corrigirHtml = functionDate.formatKey(
      Textnotifications.getCorrigirPrompt()
    );
  }
  return (
    <SmallModal
      titleModal="Aviso"
      inputMotivo="sim"
      titleLabel="Explique o motivo"
      inputNCM="sim"
      titleDescription={
        <div
          className="space titleAprover"
          dangerouslySetInnerHTML={{
            __html: corrigirHtml,
          }}
        />
      }
      bodyModal=""
      buttonOne="Corrigir"
      onConfirm={onConfirm}
      buttonTwo="Cancelar"
      onClose={onClose}
      commentText={corrigirText}
      ncmCode={ncmCode}
      setCommentText={setCorrigirText}
      setNcmCode={setNcmCode}
      isButtonDisabled={isButtonDisabled}
      onDisableButton={onDisableButton}
      isSubmitting={isSubmitting}
      ncmError={ncmApiError}
      setNcmError={setNcmApiError}
    />
  );
};
